import axios from "axios";
import { APIService, getCarrierName } from "../utilities/Constants";
import { getBaseUrl } from "./config/apiConfig";
import { apiGet } from "./utils/apiUtils";
import { ErrorHandler, handleApiError } from "./utils/errorUtils";
import { generateHeaders } from "./utils/headerUtils";
import { DocumentItem } from "../hooks/docs/DocumentParser";
import { messages } from "../../src/resources/strings";
import { handleError403Introspection, handleError500, introspectionAPI } from "./user";

//API :: Docs & Info - Get document
export const getDocumentUrls = async (policyNumber: string) => {
  const customErrorHandlers: ErrorHandler[] = [
    {
      case: 403,
      onError: () => {
        handleError403Introspection(messages.error.noDataFound);
      },
    },
  ];

  const response = await apiGet<any>(
    APIService.harmony,
    `/policy/${policyNumber}/files`,
    {},
    { policySource: getCarrierName() },
    customErrorHandlers
  );

  if (response.status === 200) {
    let documentsObjectArray = response.result;
    if (documentsObjectArray && documentsObjectArray?.length && policyNumber) {
      documentsObjectArray = documentsObjectArray?.map((item: any) => ({
        policyNumber: policyNumber,
        ...item,
      }));
    }
    return {
      response: documentsObjectArray,
      errorCode: messages.error.noError,
    };
  } else {
    return {
      errorCode: messages.error.somthingWrong,
    };
  }
};

//API :: Docs & Info - Get documents urls
export const getPDF = async (document: DocumentItem) => {
  const customErrorHandlers: ErrorHandler[] = [
    {
      case: 403,
      onError: () => {
        handleError403Introspection(messages.error.documentDownloadFailed);
      },
    },
    {
      case: 500,
      onError: () => {
        return handleError500(messages.error.documentDownloadFailed);
      },
    },
  ];
  let requestUrl =
    getBaseUrl(APIService.harmony) +
    `/policy/${document.policyNumber}/file/${
      document.id
    }?policySource=${getCarrierName()}`;

  try {
    const header = await generateHeaders({ isForPDF: true });
    const response = await axios.get(requestUrl, {
      headers: header,
      responseType: "blob",
    });

    if (response.status === 200) {
      const blob = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(blob);
      return {
        response: fileURL,
        errorCode: messages.error.noError,
      };
    } else {
      return {
        errorCode: messages.error.documentDownloadFailed,
      };
    }
  } catch (error: any) {
    return handleApiError(error, customErrorHandlers);
  }
};
